import { useRef as u } from "react";
const l = function(o, c) {
  var r = u(!1), e = u(null);
  function m() {
    clearTimeout(e.current), r.current = !0, e.current = setTimeout(function() {
      r.current = !1;
    }, 50);
  }
  var t = u({
    top: o,
    bottom: c
  });
  return t.current.top = o, t.current.bottom = c, function(a) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = (
      // Pass origin wheel when on the top
      a < 0 && t.current.top || // Pass origin wheel when on the bottom
      a > 0 && t.current.bottom
    );
    return i && n ? (clearTimeout(e.current), r.current = !1) : (!n || r.current) && m(), !r.current && n;
  };
};
export {
  l as default
};
//# sourceMappingURL=useOriginScroll.mjs.map
